import React, { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

import './general-table.scss';

interface GeneralTableDataProps extends HTMLAttributes<HTMLTableCellElement> {
  children: ReactNode;
  className?: string;
}

const GeneralTableData: React.FC<GeneralTableDataProps> = ({ children, className = '', ...rest }) => {
  return (
    <td {...rest} className={clsx('general-table-data', className)}>
      {children}
    </td>
  );
};

export default GeneralTableData;
